exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.avatar-uploader[data-v-76555e56] {\n  border: 1px dashed #d9d9d9;\n  border-radius: 6px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  display: inline-block;\n  width: 100px;\n  height: 100px;\n}\n.avatar-uploader[data-v-76555e56]:hover {\n  border-color: #409EFF;\n}\n.avatar-uploader-icon[data-v-76555e56] {\n  font-size: 28px;\n  color: #8c939d;\n  width: 100px;\n  height: 100px;\n  line-height: 100px;\n  text-align: center;\n  display: block;\n}\n.avatar[data-v-76555e56] {\n  width: 100px;\n  height: 100px;\n  display: block;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n", ""]);

// exports
